var _excluded = ["title", "children", "extra", "HeadProps"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { Box, Paper, Stack, styled } from '@mui/material';
var CardRoot = styled(Paper)(function (_ref) {
  var theme = _ref.theme;
  return {
    padding: theme.spacing(2)
  };
});
var Card = function Card(_ref2) {
  var title = _ref2.title,
    children = _ref2.children,
    extra = _ref2.extra,
    HeadProps = _ref2.HeadProps,
    other = _objectWithoutProperties(_ref2, _excluded);
  return /*#__PURE__*/React.createElement(CardRoot, other, (title || extra) && /*#__PURE__*/React.createElement(Stack, _extends({
    direction: "row",
    justifyContent: "space-between",
    alignItems: "center",
    sx: {
      mb: 2
    }
  }, HeadProps), /*#__PURE__*/React.createElement(Box, null, title), extra), children);
};
export default Card;